export const getBuyerProtectionDuration = (code?: string | null): number => {
    switch (code) {
        case 'MONEY_BACK_GUARANTEE_7_DAYS':
            return 7;
        case 'MONEY_BACK_GUARANTEE_30_DAYS':
            return 30;
        case 'MONEY_BACK_GUARANTEE_60_DAYS':
            return 60;
        case 'MONEY_BACK_GUARANTEE_90_DAYS':
            return 90;
        case 'MONEY_BACK_GUARANTEE_120_DAYS':
            return 120;
        default:
            // default buyer protection duration is 7 days for everyone, excluding trade users
            return 7;
    }
};
